import React, { Component } from 'react';
import PropTypes from 'prop-types';
export default class PlaceValueContainer extends Component {
    static propTypes = {
        children: PropTypes.node,
        placeholder: PropTypes.string,
        value: PropTypes.object
    };

    render () {
        const { item } = this.props;

        switch (item.type) {
            case 'step':
                return item.step.title
            case 'locality':
                return value.step.title + " - "+ value.locality.title
            case 'stop':
                return value.step.title + " - "+ value.step.title + ' - ' + value.locality.title
        }
    }
}
